import Cookies from "js-cookie";

const deleteSkill = async ({ commit, rootGetters, dispatch }, payload) => {
    commit("SET_SKILL_ACTION_LOADING", true);
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, customer_id: customer.customer_id, userId: Cookies.get('userId') };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.delete(`/proxy/ai/workspaces/${data.workspaceId}/skills/${data.skillId}?customer_id=${data.customer_id}`);

        if (response && response.data.success) {
            commit('DELETE_SKILL', data.skillId);
            return { success: true };
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message || "Failed to delete skill", { root: true });
        throw error;
    } finally {
        commit("SET_SKILL_ACTION_LOADING", false);
    }
};

export default deleteSkill;